import { render, staticRenderFns } from "./CcPreviewAdCard.ts.vue?vue&type=template&id=dabcc34e"
import script from "./CcPreviewAdCard.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./CcPreviewAdCard.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CcPreviewAdCard.ts.vue?vue&type=style&index=0&id=dabcc34e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports